const copyToClipboard = str => {
   const textarea = document.createElement('textarea');
   textarea.setAttribute('readonly', '');
   textarea.style.position = 'absolute';
   textarea.style.left = '-9999px';
   textarea.style.zIndex = '9999';
   textarea.textContent = str;

   document.body.appendChild(textarea);

   const selection = document.getSelection();
   const range = document.createRange();

   range.selectNode(textarea);
   selection.removeAllRanges();
   selection.addRange(range);

   document.execCommand('copy');

   selection.removeAllRanges();
   document.body.removeChild(textarea);
};

export default copyToClipboard;
